/**
 * Single source of truth for joy-web's supported language codes.
 *
 * Every code is an explicit BCP 47 lowercase-base + uppercase-region tag.
 * See `src/locales/README.md` for the procedure when adding a new language.
 * Consumers pass this array to `@withjoy/locale`'s `resolveLocale()` and
 * `buildI18nextConfig()` to get canonical closest-sibling resolution.
 */
export const LANGUAGES = {
  ENGLISH_BASE: 'en-US',
  ENGLISH_UK: 'en-GB',
  ENGLISH_AU: 'en-AU',
  SPANISH: 'es-ES',
  GERMAN: 'de-DE',
  FRENCH: 'fr-FR',
  ITALIAN: 'it-IT',
  JAPANESE: 'ja-JP',
};

export const SUPPORTED_LANGUAGE_CODES = Object.values(LANGUAGES);

export const DEFAULT_LANGUAGE = LANGUAGES.ENGLISH_BASE;

/**
 * Cookie persisting a guest's language pick from the guest-site selector
 * (PRNT-4574). Path-scoped to /<eventHandle> so choices are per event and the
 * cookie is never sent on admin routes. Read server-side by the i18next
 * LanguageDetector (see getInitOptions) so SSR first paint matches.
 */
export const GUEST_LANGUAGE_COOKIE_NAME = 'joyGuestLanguage';

/**
 * Base language part of `DEFAULT_LANGUAGE`. Helpful for comparisons against
 * a region-stripped language code (e.g. `locale.language.split('-')[0]`)
 * where you want to ask "is this the default language family?" without
 * caring about the region tag.
 */
export const DEFAULT_LANGUAGE_BASE = DEFAULT_LANGUAGE.split('-')[0];
